import { render, staticRenderFns } from "./PreviewInfo.vue?vue&type=template&id=7c2865a0&scoped=true&"
import script from "./PreviewInfo.vue?vue&type=script&lang=js&"
export * from "./PreviewInfo.vue?vue&type=script&lang=js&"
import style0 from "./PreviewInfo.vue?vue&type=style&index=0&id=7c2865a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2865a0",
  null
  
)

export default component.exports